import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";




const columns = [
  { id: "registrationno", label: "Registration No", minWidth: 170 },
  { id: "name", label: "Name", minWidth: 170 },
  { id: "fathername", label: "Father Name", minWidth: 170 },
  { id: "dateofbirth", label: "Date oF Birth", minWidth: 170 },
  { id: "mobileno", label: "Mobile No", minWidth: 170 },
  { id: "fees", label: "Fees", minWidth: 100 },
];

const PaginationData = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [data, setData] = useState([]);
  console.log(data);

  useEffect(() => {
    // Fetch data from the server based on the current page and rowsPerPage
    fetchData();
  }, [page, rowsPerPage]);

  const fetchData = async () => {
    // Replace this URL with your actual server endpoint for fetching paginated data
    const apiUrl = `${process.env.REACT_APP_BACKEND_URL}/api/studentdata?page=${
      page + 1
    }&perPage=${rowsPerPage}`;

    try {
      const response = await fetch(apiUrl);
      const result = await response.json();
      console.log(response.da);
      // Update the state with the fetched data
      setData(result.items);
      setTotalRows(result.totalRows);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    
    <Paper
      style={{
        width: "99%",
        overflow: "hidden",
        border: "2px solid black",
        borderRadius: "10px",
        marginLeft: "2px",
        marginBottom:'10px'
      }}
    >
      <TableContainer style={{ maxHeight: 440, background: "#f2f2f2" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead style={{ background: "#ffffff" }}>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align="left"
                  style={{ minWidth: column.minWidth, fontFamily: "Arvo" }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <>
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row.registrationno}
                >
                  
                  {columns.map((column) => (
                    <>
                      <TableCell key={column.id} align="left">
                        {row[column.id]}
                      </TableCell>
                    </>
                  ))}
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
   
  );
};

export default PaginationData;
